module.exports = __webpack_public_path__ + "img/20190805162104QQ截图20190804233652.080991c0.png";